
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalNorth as ObiBuoySphericalNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-north.js';
 
 
 

 
 export const ObiBuoySphericalNorth = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-north',
   elementClass: ObiBuoySphericalNorthElement,
   events: {
     
   }
  });
 
 